<script>
export default {
    name: "FilterButton",
    emits: ["delete", "edit"],
    props: {
        index: {
            type: Number,
            required: true
        },
        connectedUser: {
            type: Object,
            required: true
        },
        filter: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        batchComplete: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            color: this.filter.color || '#000b38cc',
            showSpinner: true  // Always true at start
        };
    },
    watch: {
        batchComplete(newVal) {
            // Show/hide spinner based on batch complete status
            if (newVal === true) {
                this.showSpinner = false;
            } else if (newVal === false) {
                this.showSpinner = true;
            }
        },
        'filter.color'(newColor) {
            this.color = newColor || '#000b38cc';
        }
    },
    methods: {
        onDeleteFilter(filter) {
            this.$emit("delete", filter);
        },
        onEditFilter(filter) {
            this.$emit("edit", filter);
        },
    }
};
</script>

<template>
    <button class="tw-filter-button" :style="{ '--tw-filter-color': color }">
        <div class="tw-filter-content">
            <div class="tw-filter-main">
                <span v-if="showSpinner" class="tw-filter-count-loading">
                    <q-spinner-dots size="16px" :color="color" />
                </span>
                <span v-else class="tw-filter-count" :style="{ 'color': color }">
                    {{ filter.count || 0 }}
                </span>
                <span class="tw-filter-title">{{ filter.description }}</span>
                <q-tooltip anchor="top middle" self="bottom middle" :delay="300">
                    {{ filter.description }}
                </q-tooltip>
            </div>
        </div>
        <div class="tw-filter-actions" v-if="filter?.whoCreated === connectedUser?.username">
            <button @click.stop="onEditFilter(filter)" class="action-btn action-edit">
                <i class="fas fa-pen"></i>
            </button>
            <button @click.stop="onDeleteFilter(filter)" class="action-btn action-delete">
                <i class="fas fa-trash"></i>
            </button>
        </div>
    </button>
</template>
<style scoped lang="scss">
.tw-filter-button {
    position: relative;
    border-radius: 8px;
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    overflow: visible;
    animation: dynamic-fade-in 0.4s ease forwards;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
    border: 1px solid #e5e7eb;
    border-left: 3px solid var(--tw-filter-color);
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
    font-family: 'Work Sans', sans-serif;
}

.tw-filter-button:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
    background-color: #fafbfc;
}

.tw-filter-button:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.tw-filter-content {
    display: flex;
    align-items: center;
    padding: 12px 14px;
    flex: 1;
    overflow: hidden;
}

.tw-filter-main {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    overflow: hidden;
}

.tw-filter-count {
    background: #f3f4f6;
    color: #6b7280;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    flex-shrink: 0;
}

.tw-filter-count-loading {
    color: #9ca3af;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.tw-filter-title {
    font-size: 13px;
    font-weight: 500;
    color: #1f2937;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    text-align: left;
}

.tw-filter-actions {
    position: absolute;
    top: 0;
        right: 0;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    gap: 8px;
    opacity: 0;
    visibility: hidden;
    transition: all 0.25s ease;
    background: white;
    padding: 6px 8px;
    border-radius: 6px;
}

.tw-filter-button:hover .tw-filter-actions {
    opacity: 1;
    visibility: visible;
}

.action-btn {
    all: unset;
    cursor: pointer;
    transition: all 0.2s ease;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding: 5px;
}

.action-btn:hover {
    background: #f3f4f6;
}

.action-btn:active {
    transform: scale(0.95);
}

.action-btn i {
    transition: color 0.2s;
    font-size: 11px;
}

.action-edit i {
    color: #3699FF;
}

.action-edit:hover i {
    color: #2884E8;
}

.action-delete i {
    color: #ef4444;
}

.action-delete:hover i {
    color: #dc2626;
}

@keyframes dynamic-fade-in {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}
</style>
